var VerticalLayoutModule = /** @class */ (function () {
    function VerticalLayoutModule() {
    }
    return VerticalLayoutModule;
}());
export { VerticalLayoutModule };
